import { render, staticRenderFns } from "./FlowPlaceholder.vue?vue&type=template&id=0388318e&"
import script from "./FlowPlaceholder.vue?vue&type=script&lang=js&"
export * from "./FlowPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./FlowPlaceholder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports